import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule, mapToCanActivate } from '@angular/router';

import { FreemiumWatchlistComponent } from './freemium-watchlist.component';
import { AuthGuard } from '../../../services/authguard-service';

const appRoutes: Routes = [
  {
    path: '',
    component: FreemiumWatchlistComponent,
    canActivate: mapToCanActivate([AuthGuard])
  }
];

export const appRoutingProviders: any[] = [];

export const routing: ModuleWithProviders<any> =
  RouterModule.forChild(appRoutes);
